import {
  Button,
  Empty,
  Skeleton,
  TablePaginationConfig,
  Tooltip,
} from 'antd';
import { SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Table } from 'components';
import { StyledTableHeader } from 'components/table/table.styled';
import { TableLoader } from 'components/table-loader/table-loader';
import { Dispatch, SetStateAction, useState } from 'react';
import { User } from 'types';

import { TicketSelFilterFormValuesPaginated } from '../ticket-selection-filter-form/type';
import { EditOutlined } from '@ant-design/icons';
import { EditTicketSeatModal } from '../edit-ticket-seat-model/edit-ticket-seat-model';

type ParticipateTableProps = {
  isSocialListLoading: boolean;
  DeliveryList: any;
  refetch: any;
  tableParams: TicketSelFilterFormValuesPaginated;
  updateParams: Dispatch<SetStateAction<TicketSelFilterFormValuesPaginated>>;
};

export const TicketSelectionList = ({
  DeliveryList,
  isSocialListLoading,
  tableParams,
  updateParams,
}: ParticipateTableProps) => {

  const handleTableChange = (
    pagination: TablePaginationConfig,
    sorter: SorterResult<User> | SorterResult<User>[],
  ) => {
    updateParams({
      ...tableParams,
      page: pagination.current,
      size: pagination.pageSize,
      order_by: Array.isArray(sorter)
        ? undefined
        : sorter.order === 'ascend'
          ? 'name'
          : '-name',
    });
  };



  // const [loadingState, setLoadingState] = useState<{
  //   id: number | null;
  //   action: string | null;
  // }>({
  //   id: null,
  //   action: null,
  // });

  // const { confirm } = Modal;

  // const showDeleteConfirm = (event: any, id: any, type: string) => {
  //   event.stopPropagation();
  //   confirm({
  //     title: `Are you sure you want to ${type === 'approve' ? 'Approve' : 'Reject'
  //       } ? `,
  //     icon:
  //       type === 'approve' ? <CheckCircleOutlined /> : <CloseCircleOutlined />,
  //     okText: 'Yes',
  //     okType: 'danger',
  //     cancelText: 'No',
  //     onOk() {
  //       setLoadingState({ id, action: type });
  //       handleUpdateStatus(id, type);
  //     },
  //     onCancel() {
  //       setLoadingState({ id: null, action: null }); // Reset loading state on cancel
  //     },
  //   });
  // };

  // const { mutate: updateStatusMutate } = useEventActiveStatus();
  // const { mutate: generatePaylinkMutate } = useGeneratePaymentLinkBoot();

  // const handleUpdateStatus = (id: any, type: string) => {
  //   const statusFormData = {
  //     id: id,
  //     status: type === 'approve' ? true : false,
  //     flag: type === 'approve' ? 'BOOTH_CONFIRM' : 'BOOTH_REJECT',
  //   };
  //   updateStatusMutate(statusFormData, {
  //     onSettled: () => {
  //       setLoadingState({ id: null, action: null });
  //     },
  //   });
  // };

  const [showModal, setShowModal] = useState(false);
  const [boothData, setBoothData] = useState<any>(null);

  const handleCloseModal = () => {
    setShowModal(false);
    setBoothData(null);
    document.body.style.overflow = 'visible';
  };

  const handleOpenModal = (record: any) => {
    setShowModal(true);
    setBoothData(record);
    document.body.style.overflow = 'hidden';
  };

  // const handleGenerateLink = (record: any) => {
  //   const payloadLink = {
  //     booth_registration_id: record?.booth_registration_id,
  //     total_price: record?.total_price,
  //   };

  //   generatePaylinkMutate(payloadLink);
  // };
  // const handleNavigate = (record: any) => {
  //   debugger;
  //   navigate(
  //     `/transactions/expo-booth-list/${record.booth_registration_id}/details`,
  //   ); // Navigate with encoded name
  // };

  function capitalizeFirstLetter(str: string) {
    if (!str) return '';

    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  return (
    <>
      <div className={`cstmrightmdl ${showModal && 'show'}`}>
        <EditTicketSeatModal
          onClose={handleCloseModal}
          isOpen={showModal}
          boothData={boothData}
        />
      </div>

      <StyledTableHeader>
        <div style={{ marginTop: '32px', color: 'black' }}>
          <RecordCountBadge
            text={'Tickets'}
            count={isSocialListLoading ? 0 : DeliveryList?.total || 0}
          />
        </div>
      </StyledTableHeader>
      <Table
        dataSource={isSocialListLoading ? [] : DeliveryList?.items}
        className='cstltblwthldr'
        locale={{
          emptyText: isSocialListLoading ? (
            <Skeleton
              active={true}
              paragraph={{
                rows: tableParams.size || 5,
              }}
            />
          ) : (
            <Empty />
          ),
        }}
        loading={
          isSocialListLoading && {
            indicator: (
              <div>
                <TableLoader />
              </div>
            ),
          }
        }
        rowKey='booth_registration_id'
        onChange={handleTableChange}
        pagination={{
          current: tableParams?.page,
          defaultPageSize: tableParams?.size,
          total: DeliveryList?.total,
          // showSizeChanger: false
        }}
        // onRow={(record: any) => {
        //   return {
        //     onClick: () => {
        //       const selection = window?.getSelection()?.toString();
        //       if (!selection?.length) {
        //         handleNavigate(record);
        //       }
        //     },
        //   };
        // }}
        scroll={{ x: 1040 }}
      >

        <Column
          title={'Event Name'}
          // dataIndex={'invoice_no'}
          // className='pointer invoice_bld'
          // sorter={true}
          // sortDirections={['ascend', 'descend', 'ascend']}
          // defaultSortOrder={'ascend'}
          // onCell={(record: any) => {
          //   return {
          //     onClick: () => {
          //       // const selection1 = window?.getSelection()?.toString();

          //       if (location.pathname == '/transactions/expo-booth-list') {
          //         navigate(getRoute(ROUTES.TRANSACTION_EXPO_BOOTH_LIST_DETAILS, record.EventId));
          //       } else {
          //         navigate(getRoute(ROUTES.TRANSACTION_TICKET_SEATS_LIST_DETAILS, record.EventId));
          //       }
          //     },
          //   };
          // }}
          render={(record: any) => {
            return (
              // <span className='arow_tab'>
              //   <RightOutlined />
              <h1>{record.EventName}</h1>
              // </span>

            )
          }}
        />
        {/* <Column
                    title={'Invoice Id'}
                    dataIndex={'invoice_id'}
                /> */}
        {/* <Column title={'Event Name'} dataIndex={'event_name'} /> */}

        <Column
          title={'First Name'}
          dataIndex={'FirstName'}
        // sorter={true}
        // sortDirections={['ascend', 'descend', 'ascend']}
        // defaultSortOrder={'ascend'}
        />
        <Column
          title={'Last Name'}
          dataIndex={'LastName'}
        // sorter={true}
        // sortDirections={['ascend', 'descend', 'ascend']}
        // defaultSortOrder={'ascend'}
        />
        <Column title={'Email'} dataIndex={'Email'} />

        <Column title={'Seat No'} dataIndex={'SeatNumbers'} />
        <Column title={'Price'}
          // dataIndex={'TotalPrice'}
          render={(record: any) => {
            return (
              <span className='arow_tab'>
                <h1>{record.TotalPrice}</h1>
                <h1>{record.CurrencyName}</h1>
              </span>

            )
          }}
        />

        <Column
          title={'Status'}
          render={(record: any) => {
            return (
              <h1>
                {
                  record?.PaymentStatus == "CAPTURED" ? "Paid" :
                    capitalizeFirstLetter(record?.PaymentStatus)
                }
              </h1>
            );
          }}
        />

        <Column<any>
          title={'Action'}
          // width={screens.xxl ? 'auto' : 162}
          // dataIndex={'is_active'}
          render={(_, item) => (
            <>

              <Tooltip title='Edit booth'>
                <Button
                  size='small'
                  shape='circle'
                  icon={<EditOutlined />}

                  onClick={() => handleOpenModal(item)}
                />
              </Tooltip>

            </>
          )}
        />
      </Table>
    </>
  );
};
